import { Grid, MenuItem, TextField } from '@mui/material';
import { useState } from 'react';
import { useLegalClientStore } from '../../../../generic/legalClientStore';
import { NavRow } from '../../../../generic/NavRow';
import { Tree, TreeNodeId } from '../types';

type StringSet = Set<string>;

function getAncestors(
  tree: Tree,
  nodeId: TreeNodeId,
  ancestors: Set<TreeNodeId> = new Set()
): StringSet {
  const node = tree[nodeId];
  if (!node) {
    return ancestors;
  }

  const parentNodes = node.parents || [];
  for (const parentId of parentNodes) {
    if (!ancestors.has(parentId)) {
      ancestors.add(parentId);
      getAncestors(tree, parentId, ancestors);
    }
  }

  return ancestors;
}

function getChildren(
  tree: Tree,
  nodeId: TreeNodeId,
  children: Set<TreeNodeId> = new Set()
): StringSet {
  const node = tree[nodeId];
  if (!node) {
    return children;
  }

  const childNodes = node.children || [];
  for (const childId of childNodes) {
    if (!children.has(childId)) {
      children.add(childId);
      getChildren(tree, childId, children);
    }
  }

  return children;
}

type ChoosePartnerSlideProps = {
  tree: Tree;
  baseParentId: TreeNodeId;
  onClose: () => void;
  onNext: () => void;
  setOtherPartnerId: React.Dispatch<React.SetStateAction<number | 'new'>>;
};

export function ChoosePartnerSlide({
  tree,
  baseParentId,
  onClose,
  onNext,
  setOtherPartnerId,
}: ChoosePartnerSlideProps) {
  const [legalClientArray] = useLegalClientStore(state => [
    state.legalClientArray,
  ]);

  const [partner, setPartner] = useState<number | 'new'>('new');

  const ancestorIds = Array.from(getAncestors(tree, baseParentId)).map(Number);
  const childrenIds = Array.from(getChildren(tree, baseParentId)).map(Number);

  const allSinglePartners = [
    { id: 'new', label: 'Neuer Partner' },
    ...legalClientArray
      .filter(
        legalClient =>
          !ancestorIds.includes(legalClient.idLegalClient) &&
          !childrenIds.includes(legalClient.idLegalClient) &&
          legalClient.idLegalClient !== Number(baseParentId)
      )
      .map(legalClient => ({
        id: legalClient.idLegalClient,
        label: `${legalClient.FirstName} ${legalClient.LastName}`,
      })),
  ];

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        Wählen Sie den Partner aus, mit dem das gezeugt wurde. Wurde der Partner
        noch nicht hinzugefügt, wählen Sie bitte "Neuen Partner erstellen" aus.
      </Grid>
      <Grid item xs={12}>
        <TextField
          label='Partner auswählen'
          select
          value={partner}
          onChange={e =>
            setPartner(
              e.target.value === 'new' ? 'new' : Number(e.target.value)
            )
          }
          size='small'
          fullWidth
        >
          {allSinglePartners.map(combo => (
            <MenuItem key={combo.id} value={combo.id}>
              {combo.label}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
      <Grid item xs={12}>
        <NavRow
          handleBack={onClose}
          handleNext={() => {
            setOtherPartnerId(partner);
            onNext();
          }}
          nextButtonText={
            partner === 'new' ? 'Neuen Partner erstellen' : 'Kind erstellen'
          }
        />
      </Grid>
    </Grid>
  );
}
